export const isLocalHost = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return ['localhost', '127.0.0.1'].includes(window.location.hostname);
};

const localDefaults = {
  tdsApi: 'http://localhost:6543/api/tds',
  otpApi: 'http://localhost:6543/api',
};

const liveDefaults = {
  tdsApi: '/api/tds',
  otpApi: '/api',
};

const defaults = isLocalHost() ? localDefaults : liveDefaults;

export const apiConfig = {
  tdsApi: process.env.REACT_APP_TDS_API || defaults.tdsApi,
  otpApi: process.env.REACT_APP_OTP_API || defaults.otpApi,
};

export const showTestFiscalYear = isLocalHost();
